"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = function () {
  let defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const ref = _react.default.useRef();
  const [value, setValue] = _react.default.useState(defaultValue);
  const onFocus = _react.default.useCallback(() => {
    if (!ref.current) return;
    ref.current.focus();
  }, []);
  const onClear = _react.default.useCallback(() => {
    setValue('');
    onFocus();
  }, []);
  const onChange = _react.default.useCallback(_ref => {
    let {
      target
    } = _ref;
    setValue(target.value);
  }, []);
  return {
    ref,
    onChange,
    onFocus,
    onClear,
    setValue,
    value
  };
};
exports.default = _default;